import React from "react";

import { TableField } from "src/app/project/TableField/TableField";
import { ProjectBasicData } from "src/redux/project/types";
import { DateObject } from "src/types";
import { tableDataType } from "../Table/Table";

interface OverviewFieldProps {
  onTableValueChange?: (
    taskId: string,
    uuid: string,
    newValue: string | DateObject | null | boolean | number,
    customCurrencyCode?: string | null,
  ) => void;
  field: any;
  projectBasicData: ProjectBasicData;
}

export default function OverviewField({
  onTableValueChange,
  field,
  projectBasicData,
}: OverviewFieldProps) {
  const itemField = projectBasicData.metadata.find(
    (meta) => field.id === meta.uuid || field.uuid === meta.uuid,
  );

  const fieldValue = itemField?.value?.date
    ? itemField?.value?.date
    : itemField?.value;

  const uuid = itemField?.uuid;
  if (!itemField || !uuid) return null;
  return (
    <div className="ws-overview-fields-table__row">
      <TableField
        fieldValue={fieldValue === "" ? null : fieldValue}
        fieldData={itemField}
        onValueChange={(newValue, customCurrencyCode) => {
          if (
            (newValue || newValue === false || newValue === null) &&
            onTableValueChange
          ) {
            onTableValueChange(
              projectBasicData.projectId,
              uuid,
              newValue,
              customCurrencyCode,
            );
          }
        }}
        objectId={projectBasicData.projectId}
        uuid={uuid}
        dataType={tableDataType.Project}
      />
    </div>
  );
}
